// @core/api/endpoints/landing/create_landing_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateLandingTemplateRequest,
  LandingTemplateResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Create landing template
 * Creates a new reusable landing page template.
 */
export async function CreateLandingTemplate(
  data: CreateLandingTemplateRequest,
  options?: RequestOptions
): Promise<LandingTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/landing/templates`;
  const requestOptions = options;
  return client.post<LandingTemplateResponse>(requestPath, data, requestOptions);
}
